var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import * as _ from 'lodash';
import { AutoControlledComponent, customPropTypes, partitionHTMLProps, commonPropTypes, } from '../../lib';
import Icon from '../Icon/Icon';
import Ref from '../Ref/Ref';
import Slot from '../Slot/Slot';
/**
 * An input is a field used to elicit a response from a user.
 * @accessibility
 * For good screen reader experience set aria-label or aria-labelledby attribute for input.
 *
 * Other considerations:
 *  - if input is search, then use "role='search'"
 */
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputRef = function (inputNode) {
            _this.inputDomElement = inputNode;
            _.invoke(_this.props, 'inputRef', inputNode);
        };
        _this.handleIconOverrides = function (predefinedProps) { return (__assign({ onClick: function (e) {
                _this.handleOnClear();
                _this.inputDomElement.focus();
                _.invoke(predefinedProps, 'onClick', e, _this.props);
            } }, (predefinedProps.onClick && { tabIndex: '0' }))); };
        _this.handleChange = function (e) {
            var value = _.get(e, 'target.value');
            _.invoke(_this.props, 'onChange', e, __assign({}, _this.props, { value: value }));
            _this.trySetState({ value: value });
        };
        _this.handleOnClear = function () {
            if (_this.props.clearable) {
                _this.trySetState({ value: '' });
            }
        };
        _this.computeIcon = function () {
            var _a = _this.props, clearable = _a.clearable, icon = _a.icon;
            var value = _this.state.value;
            if (clearable && value.length !== 0) {
                return 'close';
            }
            return icon || null;
        };
        return _this;
    }
    Input.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, restProps = _a.rest, styles = _a.styles, variables = _a.variables;
        var _b = this.props, className = _b.className, input = _b.input, type = _b.type, wrapper = _b.wrapper;
        var _c = this.state.value, value = _c === void 0 ? '' : _c;
        var _d = partitionHTMLProps(restProps), htmlInputProps = _d[0], rest = _d[1];
        return Slot.create(wrapper, {
            defaultProps: __assign({ className: cx(Input.className, className), children: (React.createElement(React.Fragment, null,
                    React.createElement(Ref, { innerRef: this.handleInputRef }, Slot.create(input || type, {
                        defaultProps: __assign({}, htmlInputProps, { as: 'input', type: type,
                            value: value, styles: styles.input, onChange: this.handleChange }),
                    })),
                    Icon.create(this.computeIcon(), {
                        defaultProps: {
                            styles: styles.icon,
                            variables: variables.icon,
                        },
                        overrideProps: this.handleIconOverrides,
                    }))), styles: styles.root }, rest),
            overrideProps: {
                as: (wrapper && wrapper.as) || ElementType,
            },
        });
    };
    Input.className = 'ui-input';
    Input.displayName = 'Input';
    Input.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { clearable: PropTypes.bool, defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), fluid: PropTypes.bool, icon: customPropTypes.itemShorthand, iconPosition: PropTypes.oneOf(['start', 'end']), input: customPropTypes.itemShorthand, inputRef: PropTypes.func, inline: PropTypes.bool, onChange: PropTypes.func, type: PropTypes.string, value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), wrapper: customPropTypes.wrapperShorthand });
    Input.defaultProps = {
        type: 'text',
        wrapper: {},
        iconPosition: 'end',
    };
    Input.autoControlledProps = ['value'];
    return Input;
}(AutoControlledComponent));
export default Input;
